var React = require('react');

function WebcastPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.61605 7.00551C9.25059 6.61502 9.25059 5.69267 8.61606 5.30219L1.5241 0.937906C0.857828 0.527894 0 1.00724 0 1.78956V10.5181C0 11.3004 0.857828 11.7798 1.5241 11.3698L8.61605 7.00551Z","fill":"black"}));
}

WebcastPlay.defaultProps = {"width":"10","height":"12","viewBox":"0 0 10 12","fill":"none"};

module.exports = WebcastPlay;

WebcastPlay.default = WebcastPlay;
